import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoney = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 4C1.89688 4 1 4.89688 1 6V14C1 15.1031 1.89688 16 3 16H17C18.1031 16 19 15.1031 19 14V6C19 4.89688 18.1031 4 17 4H3ZM5 14H3V12C4.10313 12 5 12.8969 5 14ZM3 8V6H5C5 7.10313 4.10313 8 3 8ZM15 14C15 12.8969 15.8969 12 17 12V14H15ZM17 8C15.8969 8 15 7.10313 15 6H17V8ZM10 7C10.7956 7 11.5587 7.31607 12.1213 7.87868C12.6839 8.44129 13 9.20435 13 10C13 10.7956 12.6839 11.5587 12.1213 12.1213C11.5587 12.6839 10.7956 13 10 13C9.20435 13 8.44129 12.6839 7.87868 12.1213C7.31607 11.5587 7 10.7956 7 10C7 9.20435 7.31607 8.44129 7.87868 7.87868C8.44129 7.31607 9.20435 7 10 7Z",
		fill: "#0D2976"
	})
});
export default SvgMoney;
